import { render, staticRenderFns } from "./PurchaseEditLedgersMobile.vue?vue&type=template&id=4fa91c44&scoped=true"
import script from "./PurchaseEditLedgersMobile.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditLedgersMobile.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditLedgersMobile.vue?vue&type=style&index=0&id=4fa91c44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa91c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fa91c44')) {
      api.createRecord('4fa91c44', component.options)
    } else {
      api.reload('4fa91c44', component.options)
    }
    module.hot.accept("./PurchaseEditLedgersMobile.vue?vue&type=template&id=4fa91c44&scoped=true", function () {
      api.rerender('4fa91c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditLedgersMobile.vue"
export default component.exports